import { generateVideoUrl as i, parseUrl as a } from "../../helpers/video-url-parser.js";
import { BLOCK_CLASSES as t } from "../../constants.js";
const l = {
  inline: !1,
  attrs: {
    type: { default: "video" },
    provider: { default: "youtube" },
    id: { default: "" }
  },
  group: "block",
  parseDOM: [
    {
      tag: "iframe",
      getAttrs(e) {
        let { provider: r, id: o } = a(e.src);
        return { provider: r, id: o };
      }
    }
  ],
  toDOM(e) {
    let r = i(e.attrs.provider, e.attrs.id);
    return [
      "div",
      {
        class: `${t.blockContainer} ${t.video}`
      },
      [
        "iframe",
        {
          src: r,
          style: "pointer-events: none;"
        }
      ]
    ];
  }
};
export {
  l as videoSpec
};
